"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Direction_1 = __importDefault(require("../enums/Direction"));
const state_1 = __importDefault(require("../state"));
const getCootsScreenCoords_1 = __importDefault(require("./getCootsScreenCoords"));
const getCootsDirection = () => {
    if (state_1.default.hasMouseScreenCoords() && state_1.default.isInBed === false) {
        const centerScreenCoords = (0, getCootsScreenCoords_1.default)();
        const right = state_1.default.mouseScreenCoords.x > centerScreenCoords.x;
        const up = state_1.default.mouseScreenCoords.y < centerScreenCoords.y;
        if (up && right) {
            return Direction_1.default.UpRight;
        }
        if (up && right === false) {
            return Direction_1.default.UpLeft;
        }
        if (up === false && right) {
            return Direction_1.default.DownRight;
        }
        if (up === false && right === false) {
            return Direction_1.default.DownLeft;
        }
    }
    return Direction_1.default.DownLeft;
};
exports.default = getCootsDirection;
